import { render, staticRenderFns } from "./ChooseDocument.vue?vue&type=template&id=a24fa63c&scoped=true&"
import script from "./ChooseDocument.vue?vue&type=script&lang=ts&"
export * from "./ChooseDocument.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseDocument.vue?vue&type=style&index=0&id=a24fa63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24fa63c",
  null
  
)

export default component.exports